export default () => ({
    modal: null,

    init() {

    }
});